<h2 mat-dialog-title mat-dialog-draggable-title>Vẽ chữ ký</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <canvas #myCanvas id="canvas" width="600pt" height="300pt" style="border:1px solid"></canvas>

  <div id="bottom-toolbar">
    <div class="left">
      <button mat-stroked-button color="primary" class="mr-3" (click)="clearCanvas()" type="button">
        <span class="material-icons">delete_forever</span>Xoá</button>
    </div>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="center">
  <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.cancel' | translate}}
  </button>
  <button mat-raised-button type="submit" (click)="onSaveCanvas()"  color="primary">Xác nhận</button>
</mat-dialog-actions>
